// extracted by mini-css-extract-plugin
export default {"NoteCard":"NoteCard_NoteCard__eFtvD","note":"NoteCard_note__8vyDg","stars":"NoteCard_stars__fE5Gu"};